/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1PersonIdPhoto204,
  DeleteApiV1PersonIdPhoto401,
  DeleteApiV1PersonIdPhoto404,
  DeleteApiV1PersonIdPhoto500,
  DeleteApiV1PersonIdPhotoMutationResponse,
  DeleteApiV1PersonIdPhotoPathParams,
} from "../../types/personRegisterController/DeleteApiV1PersonIdPhoto.ts";

export const deleteApiV1PersonIdPhotoPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1PersonIdPhotoPathParams>;

/**
 * @description Foto removida.
 */
export const deleteApiV1PersonIdPhoto204Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonIdPhoto204>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1PersonIdPhoto401Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonIdPhoto401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1PersonIdPhoto404Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonIdPhoto404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1PersonIdPhoto500Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonIdPhoto500>;

export const deleteApiV1PersonIdPhotoMutationResponseSchema = z.lazy(
  () => deleteApiV1PersonIdPhoto204Schema,
) as unknown as ToZod<DeleteApiV1PersonIdPhotoMutationResponse>;
